import React, { useState } from "react";
import { SelectedFarmContainer } from "features/shared/crossCuttingComponents";
import { Switch, Route, Redirect } from "react-router-dom";

import { AppBar as AppBarCustomizado, AppBarConteudoDefault } from "../layout";
import { NavegacaoTabs } from "../navegacao";
import SupplementationRouter from "./supplementation/views/supplementationRouter";
import { useTranslations } from "adapters/i18n";

const COLLECT_TABS = (t) => [
{
  id: "supplementation",
  label: t("supplementation:supplementation"),
  show: true,
}
];

const CollectRouter = ({ match }) => {
  const { t } = useTranslations();

  const [selectedTab, setSelectedTab] = useState(t("supplementation:supplementation"));

  const onChangeTab = (event) => {
    console.log({ event });
    setSelectedTab(event.target.id);
  };

  const farmNameAppBar = () => {
    return (
      <SelectedFarmContainer
        render={(fazenda, { noFarmSelectedTitle }) => {
          const textoSecundarioAppBar = fazenda
            ? fazenda.NomeReduzido
            : t("common:no-farm-selected");
          return <AppBarConteudoDefault tituloAppBar={textoSecundarioAppBar} />;
        }}
      />
    );
  };

  return (
    <>
      <AppBarCustomizado
        conteudoCustomizadoAppBar={farmNameAppBar()}
        id="appBarPersonalizado"
      />
      <NavegacaoTabs
        tabs={COLLECT_TABS(t)}
        mudarTab={onChangeTab}
        abaSelecionada={selectedTab}
        styles={{
          backgroundColor: "#f8f8f8",
          minHeight: 60,
          display: "flex",
          alignItems: "center",
        }}
        estilosTab={{
          fontSize: 16,
        }}
      />
      <div style={styles.contentWrapper}>
        <Switch>
          <Route exact path={`${match.path}/`}>
            <Redirect to={`${match.path}/suplementacao`} />
          </Route>
          <Route
            path={`${match.path}/suplementacao`}
            component={SupplementationRouter}
          />
        </Switch>
      </div>
    </>
  );
};

const styles = {
  contentWrapper: {
    width: "100%",
    minHeight: "93vh",
    paddingTop: 20,
    paddingBottom: 40,
    backgroundColor: "#fff",
  },
  appBarTitle: {
    fontFamily: "Roboto",
    fontSize: "18px",
    color: "#444",
  },
};
export default CollectRouter;
